<template lang="html">
    <div class="panel shaded">
        <h5>Extra Ticket Information</h5>

        <!-- Info -->
        <div class="fs-small dark">This information will be added on the customer’s ticket depending on the following conditions:</div>

        <!-- Extra Ticket Info Containers -->
        <div>
            <div v-for="ticketExtraInformation in activeTicketExtraInformation" class="mt-3">

                <div class="d-flex flex-row dark bold">
                    <div class="flex-grow-1">{{ticketExtraInformation.label}}</div>
                    <div class="pointer" @click="removeExtraInfo(ticketExtraInformation)">Remove</div>
                </div>

                <textarea v-model="ticketExtraInformation.text" @change="somethingChanged()"></textarea>

            </div>
        </div>

        <!-- Bottom Buttons -->
        <div class="d-flex justify-content-end align-items-center mt-3">
            <div class="mr-3">
                <v-select
                    :options="availableOptions"
                    v-model="selectedOption"
                    :disabled="noOptionsAvailable"
                    label="label">
                </v-select>
            </div>
            <button class="btn blue wide" type="button" :disabled="noOptionsAvailable" @click="addExtraInfoToProduct(selectedOption)">Add</button>
        </div>

    </div>
</template>

<script>
import extendedVSelect from '@/extends/vue-select'
import {mapActions, mapGetters} from 'vuex'
export default {
    created: function () {
        // selct the first extraTicketInfo option available
        this.updateSelectedOption()

    },
    mounted: function () {
        // if the "extraTicketInfo" array does not exists we create it
        if(!this.form.extraTicketInfo){
            this.$set(this.form, 'extraTicketInfo', [])
        }
    },
    data: function () {
        return {
            selectedOption: null
        }
    },
    props: {
        form: {
            required: true
        }
    },
    computed: {
        ...mapGetters([
            'getExtraTicketInfo'
        ]),
        availableOptions: function () {
            if(this.form.extraTicketInfo && this.form.extraTicketInfo.length > 0){

                return this.getExtraTicketInfo.filter(item => {
                    let foundAddedExtraInfo = this.form.extraTicketInfo.find(addedExtraInfo => {
                        return addedExtraInfo.id == item.id
                    })
                    if(foundAddedExtraInfo){
                        return false
                    } else {
                        return true
                    }
                })
            } else if(this.form.extraTicketInfo && this.form.extraTicketInfo.length > 0 && this.form.extraTicketInfo.length == this.getExtraTicketInfo.length) {
                return []
            } else {
                return this.getExtraTicketInfo
            }
        },
        noOptionsAvailable: function () {
            return this.availableOptions.length == 0
        },
        activeTicketExtraInformation: function () {
            return this.form.extraTicketInfo? this.form.extraTicketInfo : []
        }
    },
    methods: {
        updateSelectedOption: function () {
            if(this.availableOptions.length > 0){
                this.selectedOption = JSON.parse(JSON.stringify(this.availableOptions[0]))
            }
        },
        addExtraInfoToProduct: function(selectedOption) {
            this.form.extraTicketInfo.push(selectedOption)
            this.$emit('update:form', this.form)
            this.updateSelectedOption()
            this.somethingChanged()

        },
        removeExtraInfo: function(extraInfo) {
            let index = this.form.extraTicketInfo.indexOf(this.form.extraTicketInfo.find(i => i.id == extraInfo.id))
            this.form.extraTicketInfo.splice(index, 1)
            this.updateSelectedOption()
        },
        somethingChanged: function () {
            this.$emit('change', this.form)
        }
    },
    components:{
        vSelect: extendedVSelect,
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// TicketExtraInfo.vue?25e5f8b9